<template>
  <div class="index">
    <div>

    </div>
    <div class="module1">
      <el-carousel
        height="440px"
        style="width: 100%;"
      >
        <el-carousel-item>
          <div class="carousel-item">
            <div class="title">
              <p class="big-title">开放 共享 赋能私域生态全场景</p>
              <p class="sm-info">公众号、小程序、App、社群工具</p>
              <el-button
                type="primary"
                class="detail"
                @click="gowikeyun"
              >查看详情</el-button>
            </div>
            <img
              src="@/assets/imgs/front/img_firstbanner_index.svg"
              alt=""
            >
          </div>
        </el-carousel-item>
        <el-carousel-item class="dark">
          <div class="full-carousel-item">
            <div>
              <div class="title">
                <p class="big-title">私域电商全场景消费解决方案</p>
                <p class="sm-info">生活缴费、超级权益、导购CPS等1000+接口全面开放</p>
                <el-button
                  class="detail"
                  @click="goApiMarket"
                >查看详情</el-button>
              </div>
              <img
                src="@/assets/imgs/front/img_mainbanner_index.svg"
                alt=""
              >
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="dark">
          <div class="darkBgImg">
            <div>
              <div class="title">
                <p class="big-title">一站式数字权益解决方案</p>
                <p class="sm-info">肯德基、星巴克、麦当劳、爱奇艺、优酷等300+卡券特权</p>
                <el-button
                  class="detail"
                  @click="goApiMarket"
                >查看详情</el-button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      class="module2"
      v-if="noticeList.length"
    >
      <div
        class="notice"
        v-for="(item,index) in noticeList"
        :key="index"
        @click="gotoNotice(item)"
      >
        <p class="name">{{ item.title }}</p>
        <p class="date">{{ item.add_time }}</p>
      </div>
      <div class="notice">
        <el-button
          type="text"
          class="more"
          @click="gotoNotice('all')"
        >更多公告 <i class="el-icon-caret-right"></i>
        </el-button>
      </div>
    </div>
    <div class="module3">
      <div class="container">
        <p class="title">精准高效的解决方案</p>
        <p class="info">整合商品、渠道资源 行业领先的技术资源 驱动企业实现业绩增长</p>
        <div class="system-list">
          <div class="system">
            <i class="icon">
              <img
                src="@/assets/imgs/front/icon_locallife_index.svg"
                width="25px"
                height="28px"
              />
            </i>
            <p class="title">导购电商场景</p>
            <div class="info"> 覆盖淘宝、京东、拼多多、唯品会等导购优惠券，高效转化,商品搜索等众多API。</div>
            <div class="api-list">
              <div class="api">商品搜索</div>
              <div class="api">猜你喜欢</div>
              <div class="api">爆款排行榜</div>
              <div class="api">高效转链接</div>
            </div>
          </div>
          <div class="system">
            <i class="icon">
              <img
                src="@/assets/imgs/front/icon_shoppguide_index.svg"
                width="25px"
                height="28px"
              />
            </i>
            <p class="title">吃喝玩乐场景</p>
            <p class="info">覆盖影院、外卖、出行、团购等本地生活CPS返利，吃喝玩乐一站式消费，省钱又赚钱。</p>
            <div class="api-list">
              <div class="api">美团返利</div>
              <div class="api">滴滴打车</div>
              <div class="api">电影票API</div>
              <div class="api">周边游</div>
            </div>
          </div>
          <div class="system">
            <i class="icon">
              <img
                src="@/assets/imgs/front/icon_locallife_index.svg"
                width="25px"
                height="28px"
              />
            </i>
            <p class="title">本地服务场景</p>
            <p class="info">全品类数字权益商品，覆盖话费，电费，燃气，水费等数字化标准接口。</p>
            <div class="api-list">
              <div class="api"> 话费API</div>
              <div class="api">电费API</div>
              <div class="api">油卡充值</div>
            </div>
          </div>
          <div class="system">
            <i class="icon">
              <img
                src="@/assets/imgs/front/icon_service_index.svg"
                width="25px"
                height="28px"
              />
            </i>
            <p class="title">权益特权福利</p>
            <p class="info">集合电商购物，本地生活，生活服务，娱乐影视等1000+权益特权,提供完整的企业福利解决方案。</p>
            <div class="api-list">
              <div class="api">卡券API</div>
              <div class="api">直充API</div>
              <div class="api">会员卡</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module4">
      <p class="title">产品与服务</p>
      <p class="info">丰富的数字资源接口完善的技术支持方案</p>
      <div class="service-list">
        <div class="service">
          <img src="@/assets/imgs/front/icon_moreapi_index.svg" />
          <div class="describe">
            <p class="name">海量接口</p>
            <p class="desc">一站式对接电商、本地生活、品牌卡券接口，覆盖商品、用户交易等模块。</p>
          </div>
        </div>
        <div class="service">
          <img src="@/assets/imgs/front/icon_savetime_index.svg" />
          <div class="describe">
            <p class="name">省时省力</p>
            <p class="desc">提供聚合优惠券商城核心系统能力，大大节省人力和时间双成本。</p>
          </div>
        </div>
        <div class="service">
          <img src="@/assets/imgs/front/icon_team_index.svg" />
          <div class="describe">
            <p class="name">专业团队</p>
            <p class="desc">淘宝联盟核心团队出身，服务过众多顶级媒体，全程专人指导避免踩坑。</p>
          </div>
        </div>
        <div class="service">
          <img src="@/assets/imgs/front/icon_customize_index.svg" />
          <div class="describe">
            <p class="name">个性化定制和服务</p>
            <p class="desc">提供定制化需求服务，打造独一无二的聚合商城，满足特色化经营需求。</p>
          </div>
        </div>
        <div class="service">
          <img src="@/assets/imgs/front/icon_revenue_index.svg" />
          <div class="describe">
            <p class="name">收益透明</p>
            <p class="desc">商场收益直入客户联盟帐号，数据透明可视，做到有据可依有数可查。</p>
          </div>
        </div>
        <div class="service">
          <img src="@/assets/imgs/front/icon_addservices_index.svg" />
          <div class="describe">
            <p class="name">增值服务</p>
            <p class="desc">微客云开放平台全资源付费客户，在服务周期内可免费持续接入新引入资源。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="module5">
      <div class="container">
        <p class="title">合作优势</p>
        <p class="info">致力做您最信任的合作伙伴</p>
        <div class="cooperate-list">
          <div class="cooperate">
            <img
              src="@/assets/imgs/front/icon_business_index.svg"
              alt=""
              width="88px"
              height="88px"
            >
            <div class="describe">
              <p class="name">业务能力开放</p>
              <p class="desc">多样化开放业务场景，共建良好的电商行业生态。</p>
            </div>
          </div>
          <div class="cooperate">
            <img
              src="@/assets/imgs/front/icon_efficient_index.svg"
              alt=""
              width="88px"
              height="88px"
            >
            <div class="describe">
              <p class="name">高效服务支撑</p>
              <p class="desc">高效的对接服务，提供咨询服务号工单等多种渠道的技术支持。</p>
            </div>
          </div>
          <div class="cooperate">
            <img
              src="@/assets/imgs/front/icon_moreuser_index.svg"
              alt=""
              width="88px"
              height="88px"
            >
            <div class="describe">
              <p class="name">海量用户规模</p>
              <p class="desc">庞大的用户和商家规模，联合服务市场，实现一站式服务实现。</p>
            </div>
          </div>
          <div class="cooperate">
            <img
              src="@/assets/imgs/front/icon_system_index.svg"
              alt=""
              width="88px"
              height="88px"
            >
            <div class="describe">
              <p class="name">系统能力丰富</p>
              <p class="desc">支持PC端、移动端服务搭建并提供稳健的技术能力。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module6">
      <p class="title">一步入驻 即享专业服务</p>
      <div class="flow-list">
        <div class="flow">
          <img
            src="@/assets/imgs/front/icon_numberone.svg"
            alt=""
          >
          <p class="name">注册账户</p>
          <p class="desc">微信扫码登录/注册即可</p>
        </div>
        <div class="flow">
          <img
            src="@/assets/imgs/front/icon_numbertwo.svg"
            alt=""
          >
          <p class="name">创建应用</p>
          <p class="desc">选择相关应用类型进行创建应用</p>
        </div>
        <div class="flow">
          <img
            src="@/assets/imgs/front/icon_numberthree.svg"
            alt=""
          >
          <p class="name">选择并调试API</p>
          <p class="desc">使用微客云集开放平台提供的技术测试应用</p>
        </div>
        <div class="flow">
          <img
            src="@/assets/imgs/front/icon_numberfour.svg"
            alt=""
          >
          <p class="name">发布上线</p>
          <p class="desc">开发完成在服务市场上发布</p>
        </div>
      </div>
      <div
        class="button"
        @click="login"
      >立即入驻</div>

    </div>
  </div>
</template>

<script>
import apis from "@/api/apis";
export default {
  name: 'frontIndex',
  components: {},
  data () {
    return {
      test0: {
        test1: {
          test2: {
            test3: {

            },
            test3Arr: [
              {
                a: 1
              }
            ]
          }
        }
      },
      noticeList: []
    }
  },
  computed: {},
  mounted () {
    this.getIndex()
  },
  methods: {
    login () {
      this.$emit('login')
    },
    gowikeyun () {
      window.open(' http://www.wikeyun.cn/', '_blank')
    },
    goApiMarket () {
      this.$router.push('apiMarket')
    },
    getIndex () {
      apis.index.index().then(res => {
        this.noticeList = res.data.article
      })
    },
    gotoNotice (notice) {
      if (notice === 'all') { // 查看更多公告
        this.$router.push('/notice')
      } else { // 查看公告详情
        this.$router.push(`/notice/${notice.cate_id}/detail/${notice.id}`)
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import 'src/assets/styleVar.scss';
.index {
  width: 100%;
  .module1 {
    width: 100%;
    min-width: 1280px;
    background: linear-gradient(180deg, #ffffff 0%, #f2f5fa 100%);
    .carousel-item {
      width: 1280px;
      height: 440px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        text-align: left;
        .big-title {
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e1e28;
          line-height: 56px;
        }
        .sm-info {
          margin-top: 10px;
          font-size: 24px;
          font-weight: 400;
          color: #1e1e28;
          line-height: 33px;
        }
        .detail {
          margin-top: 60px;
        }
      }
      img {
        width: 550px;
        height: 360px;
      }
    }
    .darkBgImg {
      width: 100%;
      height: 440px;
      background-image: url('~@/assets/imgs/front/主banner.png');
      & > div {
        width: 1280px;
        height: 440px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          text-align: left;
          .big-title {
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fff;
            line-height: 56px;
          }
          .sm-info {
            margin-top: 10px;
            font-size: 24px;
            font-weight: 400;
            color: #fff;
            line-height: 33px;
          }
          .detail {
            margin-top: 60px;
          }
        }
        img {
          width: 550px;
          height: 360px;
        }
      }
    }
    .full-carousel-item {
      background: linear-gradient(
        322deg,
        #0b4ffc 0%,
        #2129fc 49%,
        #3700fc 100%
      );

      & > div {
        width: 1280px;
        height: 440px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          text-align: left;
          .big-title {
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fff;
            line-height: 56px;
          }
          .sm-info {
            margin-top: 10px;
            font-size: 24px;
            font-weight: 400;
            color: #fff;
            line-height: 33px;
          }
          .detail {
            margin-top: 60px;
          }
        }
        img {
          width: 550px;
          height: 360px;
        }
      }
    }
  }
  .module2 {
    width: 1280px;
    margin: auto;
    display: flex;
    .notice {
      width: 295px;
      height: 120px;
      padding: 34px 30px;
      cursor: pointer;
      .name {
        font-size: 16px;
        font-weight: 400;
        color: #1e1e28;
        line-height: 22px;
      }
      .date {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
      }
      ::v-deep.more {
        color: $green;
        line-height: 52px;
        span {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .module3 {
    width: 100%;
    min-width: 1280px;
    background: #fafafa;
    .container {
      width: 1280px;
      padding: 80px 0;
      margin: auto;
      .title {
        font-size: 32px;
        font-weight: 500;
        color: #1e1e28;
        line-height: 45px;
        text-align: center;
      }
      .info {
        margin-top: 10px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 28px;
        text-align: center;
      }
      .system-list {
        margin-top: 80px;
        height: 346px;
        display: flex;
        align-items: center;
        .system {
          cursor: pointer;
          width: 296px;
          height: 276px;
          background: #ffffff;
          border: 1px solid #ededed;
          transition: height 0.5s;
          padding: 40px 45px;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:hover {
            border: none;
            height: 346px;
            box-shadow: 0px 10px 40px -10px rgba(0, 0, 0, 0.1);
            .info {
              display: none;
            }
            .api-list {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
          }
          .title {
            margin-top: 30px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 36px;
          }
          .info {
            margin-top: 10px;
            width: 220px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 26px;
          }
          .api-list {
            display: none;
            .api {
              display: inline-block;
              background: $green;
              color: #fff;
              padding: 5px 10px;
              margin-right: 5px;
              margin-top: 5px;
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
  .module4 {
    width: 1280px;
    padding: 80px 0;
    margin: auto;
    .title {
      font-size: 32px;
      font-weight: 500;
      color: #1e1e28;
      line-height: 45px;
      text-align: center;
    }
    .info {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 28px;
      text-align: center;
    }
    .service-list {
      display: flex;
      flex-wrap: wrap;

      .service {
        cursor: pointer;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 30px 42px 60px 34px;
        width: 580px;
        height: 188px;
        background: #ffffff;
        border: 1px solid #ebebeb;
        display: flex;
        &:hover {
          box-shadow: 0px 20px 40px -20px rgba(0, 0, 0, 0.1);
        }
        &:nth-child(even) {
          margin-left: 20px;
        }
        .describe {
          margin-left: 20px;
          .name {
            font-size: 18px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 36px;
          }
          .desc {
            margin-top: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 26px;
          }
        }
      }
    }
  }
  .module5 {
    width: 100%;
    min-width: 1280px;
    background: #fafafa;

    .container {
      width: 1280px;
      padding: 80px 0;
      margin: auto;

      .title {
        font-size: 32px;
        font-weight: 500;
        color: #1e1e28;
        line-height: 45px;
        text-align: center;
      }

      .info {
        margin-top: 10px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 28px;
        text-align: center;
      }
      .cooperate-list {
        margin-top: 80px;
        display: flex;
        .cooperate {
          width: 280px;
          height: 304px;
          background: #ffffff;
          margin-right: 20px;
          padding: 43px 30px 0px;
          text-align: center;
          cursor: pointer;
          &:last-child {
            margin: 0;
          }
          &:hover {
            box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1);
          }
          .describe {
            margin-top: 16px;
            .name {
              font-size: 18px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 36px;
              text-align: center;
            }
            .desc {
              margin-top: 10px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
              line-height: 26px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .module6 {
    width: 1280px;
    padding: 80px 0;
    margin: auto;
    .title {
      font-size: 32px;
      font-weight: 500;
      color: #1e1e28;
      line-height: 45px;
      text-align: center;
    }
    .flow-list {
      margin-top: 80px;
      display: flex;
      .flow {
        background: #ffffff;
        margin-right: 40px;
        &:last-child {
          margin: 0;
        }
        .name {
          font-size: 28px;
          font-weight: 500;
          color: #1e1e28;
          line-height: 40px;
        }
        .desc {
          margin-top: 10px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.65);
          line-height: 25px;
        }
      }
    }
    .button {
      display: inline-block;
      background: $green;
      color: #fff;
      padding: 13px 68px;
      margin: 100px 0 0 490px;
      cursor: pointer;
    }
  }
}
</style>
